import { render, staticRenderFns } from "./CovCheck.vue?vue&type=template&id=64822fb2&"
import script from "./CovCheck.vue?vue&type=script&lang=js&"
export * from "./CovCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports